import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { borderColor } from "tailwindcss/defaultTheme";

function Dropdown({
  elements,
  component = (e, props) => <div {...props}>{e.name || e}</div>,
  componentProps,
  didSelect,
  className,
  disabled,
  selectedElement: selected,
  id,
  leftAligned = false,
  border = false,
  style = {}
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  // const [hoveredIndex, setHoveredIndex] = useState(null);
  const [selectedElement, setSelectedElement] = useState(
    selected || elements[0] || {}
  );

  useEffect(() => {
    if (selected) setSelectedElement(selected);
  }, [selected]);

  const toggle = () => {
    if (disabled) return;
    setShowDropdown(!showDropdown);
  };

  if (typeof window !== "undefined") {
    window.onclick = function(event) {
      if (!event.target.closest(".dropbtn")) {
        setShowDropdown(false);
      }
    };
  }

  // The prop "component" is a function that returns our content. Ensure that the function passed
  // uses similar values to what are passed in the "elements" prop.
  return (
    <div
      style={style}
      className={`dropdown ${
        disabled ? "dropdown-disabled" : "shadow-none"
      } bg-white border border-gray-400 pr-4 rounded rounded-sm flex w-full ${className ||
        ""}`}
    >
      <div
        onClick={toggle}
        className={`bg-white dropbtn ${
          disabled ? "dropbtn-disabled" : "cursor-pointer"
        } border-none px-1 flex w-full items-center justify-between rounded-sm border-gray-200`}
      >
        <div className="flex justify-start">
          <div className="img-xs mb-0 inline-block pr-2 md:px-2 self-center">
            {component(selectedElement, componentProps)}
          </div>
        </div>
        <i
          className={`fa fa-chevron-${
            showDropdown ? "up" : "down"
          } float-right ml-2`}
        />
      </div>
      <div
        id={id || "myDropdown"}
        className={`${
          elements.length > 10 ? "overflow-auto h-56" : ""
        } dropdown-content w-full ${!!showDropdown && "show"}`}
        data-testid="Dropdown-testSelector"
      >
        {!disabled &&
          elements.map((e, i) => {
            return (
              <button
                className={classnames(
                  `cursor-pointer px-3 flex items-center justify-between w-full`,
                  {
                    "text-left": leftAligned,
                    "border-b border-gray-400 rounded-none py-1": borderColor
                  }
                )}
                key={`${id}-${i}`}
                type="button"
                onClick={() => {
                  // TODO @{lbarrick}: Fix this. Obviously this is not ideal, but there is a race condition if there are two dropdown's on the same page.
                  setTimeout(() => {
                    didSelect(elements[i]);
                  }, 150);

                  setSelectedElement(elements[i]);
                }}
              >
                {component(e, componentProps)}
              </button>
            );
          })}
      </div>
    </div>
  );
}

Dropdown.propTypes = {
  elements: PropTypes.array,
  didSelect: PropTypes.func
};

Dropdown.defaultProps = {
  elements: [],
  didSelect: () => {}
};

export default Dropdown;
